/**
 * @module builder
 */
import type { QuoteTemplateOption } from '../index'
import { uuid } from '../../util'

export function createQuoteTemplateOption(
  args: {
    key?: string
    label?: string
    quoteTypes?: string[]
    smartTemplate?: boolean
  } = {}
): QuoteTemplateOption {
  const quoteTypes = args.quoteTypes ? args.quoteTypes : ['all']
  const label = args.label ? args.label : ''
  const key = args.key ? args.key : uuid()
  const smartTemplate = args.smartTemplate ? args.smartTemplate : false

  return {
    key,
    label,
    description: '',
    quoteTypes,
    active: true,
    smartTemplate
  }
}
